import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader, CSpinner, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CCardFooter
} from '@coreui/react';

import { apiClient } from 'services/Api';
import { jwtDecode } from 'jwt-decode';
import DataTableComponent from "components/DataTableComponent";
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";
import ToastNotification from 'components/globals/ToastNotification';
import { triggerAlert } from 'components/globals/AlertNotification';

const SstSurveyList = () => {
    const navigate = useNavigate();
    const [sstSurveys, setSstSurveys] = useState([]);
    const location = useLocation();
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear() - 1);
    const [availableYears, setAvailableYears] = useState([]);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState(null);
    const [previewSurvey, setPreviewSurvey] = useState(null);


    const token = localStorage.getItem("access_token");
    const decodedToken = jwtDecode(token);
    const is_director = decodedToken.is_director;
    const user_id = decodedToken.user_id;

    useEffect(() => {
        const fetchSstSurveys = async (year = selectedYear) => {
            try {
                const response = await apiClient.get(`/sst-surveys/?year=${year}`);
                setSstSurveys(response.data.sstSurveys);
                setAvailableYears(response.data.available_years);
            } catch (error) {
                console.error('Error fetching sstSurveys:', error);
            }
        };

        fetchSstSurveys(selectedYear);
    }, [location.pathname, selectedYear]);

    const handleSendEmails = async () => {
        setLoading(true);

        try {
            //return; // Temporarily disabled the email sending functionality
            const response = await apiClient.post(`/sst-surveys/send-emails/`);
            setToast({ title: 'Inquéritos SST', message: "Inquéritos enviados com sucesso", type: 'success' });

            const updatedResponse = await apiClient.get(`/sst-surveys/?year=${selectedYear}`);
            setSstSurveys(updatedResponse.data.sstSurveys);
            setAvailableYears(updatedResponse.data.available_years);
        } catch (error) {
            console.error("Error sending satisfaction surveys:", error);
            setToast({ title: 'Inquéritos SST', message: "Erro ao enviar os inquéritos.", type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "Colaborador", selector: (row) => row.user_name, sortable: true, className: 'text-center', grow: 2 },
        { name: "Preenchido", selector: (row) => row.concluded ? "Sim" : "Não", sortable: true, className: 'text-center' },
    ];

    return (
        <>
            <ToastNotification toast={toast} setToast={setToast} />

            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Inquéritos SST</h3>
                    <Link to="/inqueritos-sst/new">
                        <CButton color="info" className="text-white">Responder</CButton>
                    </Link>

                </CCardHeader>

                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={sstSurveys}
                        years={availableYears}
                        selectedYear={selectedYear}
                        onYearChange={(newYear) => setSelectedYear(newYear)}
                        onRowClicked={setPreviewSurvey}
                    />
                </CCardBody>
                <CCardFooter>{is_director && (
                    <CButton color="info" className="text-white" onClick={handleSendEmails} disabled={loading}>
                        {loading ? (
                            <CSpinner size="sm" />
                        ) : (
                            "Enviar Inquéritos"
                        )}
                    </CButton>
                )}
                </CCardFooter>
            </CCard>
            <RecordDetailOffcanvas
                record={previewSurvey}
                onHide={() => setPreviewSurvey(null)}
                title="Inquérito SST"
                subtitle={previewSurvey?.user_name}
                fields={previewSurvey ? [
                    { label: "Colaborador", value: previewSurvey.user_name },
                    { label: "Preenchido", value: previewSurvey.concluded ? "Sim" : "Não" },
                ] : []}
                headerActions={previewSurvey && previewSurvey.concluded && previewSurvey.user == user_id && (
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/inqueritos-sst/${previewSurvey.id}`)}>
                        Ver
                    </CButton>
                )}
            />
        </>
    );
};

export default SstSurveyList;
